export default "__VITE_ASSET__4e2b6cc3__"